<template>
  <div>
    <a class="block block-link-pop text-right block-mode-loading-refresh" href="javascript:void(0)" :class="{'block-mode-loading': isProcessing}">
      <div class="block-content block-content-full clearfix">
          <div class="float-left mt-10 d-none d-sm-block">
            <i ><font-awesome-icon icon="users" class="fa-3x text-body-bg-dark" /></i>
          </div>
          <div class="font-size-h3 font-w600" data-toggle="countTo" data-speed="1000" data-to="1500">
            {{users_count}}
          </div>
          <div class="font-size-sm font-w600 text-uppercase text-muted">В сети</div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users_count: [],
      isProcessing: false,
    };
  },
  mounted() {
    this.getUsersCount();
  },
  methods: {
    getUsersCount() {
      this.isProcessing = true;
      axios.get('/admin/stats/onlineusers/count')
        .then((res) => {
          this.users_count = res.data.users_count;
          this.isProcessing = false;
        });
    },
  },
};
</script>
